import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';

export enum RefreshTarget {
ASSIGN = 'Assign',
VOD_CENSORSHIP_PREVIEW = 'VodCensorshipPreview',
VOD_MATERIAL = 'VodMaterial',
VOD_OPERATIONS = 'VodOperations',
ENCODE_FINISH_OPERATION = 'EncodeFinishOperation',
ENCODE_START_OPERATION = 'EncodeStartOperation',
EPG_EDITOR = 'EpgEditor',
PACKAGE_START = 'PackageStart',
QUALITY_CHECK_FIRST_FINISH = 'QualityCheckFirstFinish',
QUALITY_CHECK_FIRST_START = 'QualityCheckFirstStart',
QUALITY_CHECK_SECOND_FINISH = 'QualityCheckSecondFinish',
QUALITY_CHECK_SECOND_START = 'QualityCheckSecondStart',
QUALITY_CHECK_THIRD_FINISH = 'QualityCheckThirdFinish',
QUALITY_CHECK_THIRD_START = 'QualityCheckThirdStart',
REPROCESS = 'Reprocess',
SUBTITLE_SCRIPT_CHECK_START = 'SubtitleScriptCheckStart',
THIRD_PARTY_START = 'ThirdPartyStart',
TRANSCODING_ONE_ST_FINISH = 'TranscodingOneStFinish',
TRANSCODING_ONE_ST_START = 'TranscodingOneStStart',
VIDEO_EDITING_FINISH = 'VideoEditingFinish',
VIDEO_EDITING_START = 'VideoEditingStart',
VOD_POSTERS = 'VodPosters',
DIRECT = 'Direct',
VOD_DETAIL = 'VodDetail',
VOD_EDIT = 'VodEdit',
VOD_TRAILER_MODAL = 'VodTrailerModal',
VOD_PLANNING = 'VodPlanning',
VOD_CONTENT_POSTERS = 'VodContentPosters',
VALIDATION_MANAGEMENT = 'ValidationManagement',
CONTENT_ISSUE_TYPE = 'ContentIssueType',
VOD_CONTENT_GROUP_LIST = 'VodContentGroupList',
CATEGORY_DEFINITION = 'CategoryDefinition',
LABEL_DEFINITION = 'LabelDefinition',
EDIT_LABEL = 'EditLabel',
MENU_ITEM = 'MenuItem',
CAST_MANAGEMENT = 'CastManagement',
CONTENT_LIST = 'ContentList',
CONTRACT_LIST = 'ContractList',
LICENSE_LIST = 'LicenseList',
ENCODING_PROFILES = 'EncodingProfiles',
CATCHUP_REQUEST_LIST = 'CatchupRequestList',
CATCHUP_DETAIL = 'CatchupDetail',
EPG_SECTION_INFO = 'EpgSectionInfo',
LTV_CONTENT_GROUP_LIST = 'LtvContentGroupList',
LTV_LIST_EXTENDED = 'LtvListExtended',
TRAILER_DASHBOARD = 'TrailerDashboard',
VFO_DASHBOARD = 'VfoDashboard',
CAMPAIGN_LIST = 'CampaignList',
CUSTOMER_LIST = 'CustomerList',
PRODUCT_LIST = 'ProductList',
USER_LIST = 'UserList',
CATCHUP_EXTENDED_LIST = 'CatchupExtendedList',
EPG_CORRECTION_JOBS = 'EpgCorrectionJobs',
EPG_PROGRAM_SEARCH = 'EpgProgramSearch',
CATCHUPS = 'Catchups',
CUSTOMER_ACCOUNT_INFO = 'Customer_Account_Info',
CUSTOMER_DETAIL = 'CustomerDetail',
TRIM_PLAYER = 'TrimPlayer',
ADD_CONTRACT_TO_CONTENT = 'AddContractToContent',
CATCHUP_TRIM_PROCESS = 'CatchupTrimProcess'



//refresh edilmek istenen duruma göre enum düzenlenebilir

}

@Injectable({
  providedIn: 'root'
})
export class RefreshManagerService {
  private refreshSubject = new ReplaySubject<RefreshTarget>(1);

  get refresh$(): Observable<RefreshTarget> {
    return this.refreshSubject.asObservable();
  }

  sendRefresh(target: RefreshTarget): void {
    this.refreshSubject.next(target);
  }
}